import { TBrand, TTheme, ThemeProvider } from 'telia-front-react';
import React from 'react';
import { useResolvedBrand, useResolvedTheme } from './BrandUtil';
import { injectModuleSsoCss, injectSsoCss } from './HtmlUtil';
import icons from '@teliaee/icons/sprite.svg';

import 'telia-front-react/polyfill';

const SsoThemeProvider: React.FC<{ isModule: boolean; brand?: TBrand; theme?: TTheme; children: React.ReactNode }> = ({
  isModule,
  brand: brandProp,
  theme: themeProp,
  children,
}) => {
  const brand = useResolvedBrand(brandProp);
  const theme = useResolvedTheme(themeProp, brand);

  React.useEffect(() => {
    if (isModule) {
      injectModuleSsoCss(['sso-clean-styles', `sso-prefixed-styles-${brand}`, 'sso-prefixed-custom-styles']);
    } else {
      injectSsoCss(['sso-styles-global', `sso-styles-${brand}`, 'sso-custom-styles']);
    }
  }, []);

  const getIconPath = (name: string) => {
    if (isModule) {
      return `/img/sso-icons.svg${name}`;
    }

    return icons + name;
  };

  return (
    <ThemeProvider
      brand={brand}
      theme={theme}
      getIconPath={getIconPath}
      root={isModule ? document.getElementById('sso-root') : undefined}
      portalRoot={isModule ? document.getElementById('sso-portal-root') : undefined}
    >
      {children}
    </ThemeProvider>
  );
};

export default SsoThemeProvider;
